import { gql } from "@apollo/client";

const getNextOneononeForCoachingQuery = gql`
  query getNextOneononeForCoachingQuery(
    $participants: [Int!]!
    $startDatetime: DateTime!
  ) {
    meetings(
      isFormalOneonone: true
      startDatetime_Gte: $startDatetime
      participants: $participants
      orderBy: "start_datetime"
      first: 1
    ) {
      edges {
        node {
          id
        }
      }
    }
  }
`;

export default getNextOneononeForCoachingQuery;
